import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { PolicyClient } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface PoliciesParams extends DefaultHttpHeaders {
  /** Unique User Id */
  userId?: string;
  fiscalCode?: string;
  /**
   * If this field is FALSE search policies active and not active (Canceled, expired,etc) policy , if it is TRUE only active policies
   * default: true
   */
  activePolicyInd?: boolean;
}

@Injectable()
export class PoliciesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Find User's Policies
   * Find User's Policies
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getPoliciesByUserId
   */
  policies(params: PoliciesParams): Observable<PolicyClient[]> {
    const queryParams = {
      userId: params.userId,
      fiscalCode: params.fiscalCode,
      activePolicyInd: params.activePolicyInd,
    };

    return this.get<PolicyClient[]>({
      suffix: '/comeround/applicationUtilities/policies',
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
